import Animated, { LinearTransition } from 'react-native-reanimated'
import { Button, ButtonLabel } from '~/components/ui/button'
import { cn } from '~/lib/utils'

export function MultiSelectChips<T extends string>({
  label,
  options,
  selected,
  onToggle,
  className,
}: {
  label: string
  options: { label: string; value: T }[]
  selected: T[]
  onToggle: (value: T) => void
  className?: string
}) {
  return (
    <Animated.View
      key={label}
      layout={LinearTransition.duration(150)}
      className={cn('flex-row flex-wrap gap-2', className)}>
      {options.map((opt) => {
        const isSelected = selected.includes(opt.value)
        return (
          <Button
            key={opt.value}
            testID={`multi-select-chip-${String(opt.value)}`}
            variant={isSelected ? 'default' : 'outline'}
            size="sm"
            onPress={() => onToggle(opt.value)}>
            <ButtonLabel>{opt.label}</ButtonLabel>
          </Button>
        )
      })}
    </Animated.View>
  )
}
